import { ObjectDb } from './object.db';
import { VoucherGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';
import { FilterInput } from '@it2go/data-grid';

@Injectable({ providedIn: 'root' })
export class VoucherDb extends ObjectDb<VoucherGridItemObject> {

    public tableName: string = 'voucher';

    protected override columnMap = {
        folderId: 'folderId',
        serviceId: null,
        voucherFrom: 'issueDate',
        voucherTo: 'custom::voucherTo',
    };

    protected override indices = ['id'];

    protected gqlMethod = 'getVouchers';

    protected syncFragment = `
        id
        folderId
        issueDate
        closureDate
        validTo
        sequenceNumber
        type
        updatedAt
        prescribedProcedures {
            id
            voucherId
            serviceMedicalProcedureId
            serviceMedicalProcedure {
                id
                code
                customCode
                customName
                color
                textTemplate
                procedure {
                    code
                    description
                    duration
                }
            }
            recordTemplate
            procedure {
                code
                description
                duration
            }
        }
        doctor {
            id
            titleBeforeName
            name
            surname
            titleAfterName
            email
        }
    `;

    protected override customFilter(key: string, item: VoucherGridItemObject, filter: FilterInput): boolean {
        switch (key) {
            case 'voucherTo':
                const value = item.closureDate || item.validTo;
                return this.checkValue([value], filter);
            default:
                return false;
        }
    }

}
